module.exports = __webpack_public_path__ + "static/media/2.d16b815e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/03/projects/01/2.jpg
// module id = 409
// module chunks = 0